import { useEffect } from "react";
import { useTranslation } from "react-i18next";
export function LikeButton({ long, onToggle, favorite = false, titleStyle = '', btnStyle = '', ...prop }) {
    const { t: trans } = useTranslation('info');
    return (
        <div {...prop}
            onClick={() => {
                if (onToggle) {
                    onToggle()
                }
            }}
            className={(btnStyle == '' ? "btn-like " : btnStyle + " ") + (long && "long")}>
            <p className={(titleStyle == '' ? "text-16 " : titleStyle + " ") + (long || "hidden")}>{trans('info:add_favorite')}</p>
            <img width={32} height={32} src={`/assets/icons/${favorite ? 'heart.png' : 'cleanHeart.png'}`} style={{ filter: 'brightness(0) saturate(100%) invert(39%) sepia(87%) saturate(1000%) hue-rotate(100deg) brightness(94%) contrast(96%)' }} alt={"favorite"} />
        </div>
    );
}